import React from 'react'
import { Col, Row, Container } from "react-bootstrap";
import BreadcrumbLayout from "../../../component/Breadcrumb";
import HeadPara2 from "../../../component/HeadPara2";
import { useTranslation } from "react-i18next";
import ATCSidebar from "../ATCSidebar";
export default function MobileScienceExhibitionVan() {
  const { t } = useTranslation();
  const MobileScienceExhibitionVanData = t("MobileScienceExhibitionVan", {
    returnObjects: true,
  });
  const menuData =
    t("menu.activities-of-council.popularisation-of-science", {
      returnObjects: true,
    }) || {};

  return (
    <>
      <BreadcrumbLayout title="Mobile Science Exhibition Van" />

      <Container fluid >
        <Row>
        {/* Sidebar */}
        <ATCSidebar menuData={menuData} type="PopularisationOfScience" />
          {/* Content Area */}
          <Col md={9} className="content order-md-last order-first">
            <Row>
              <Col xs={12} className="heading">
                <h3>{MobileScienceExhibitionVanData.title}</h3>
              </Col>
              <Col xs={12} className="mb-1 mt-1">
                {MobileScienceExhibitionVanData.content.map((items,i) => (
                  <HeadPara2 key={i} data={items} />
                ))}
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>

    </>
  )
}

